/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Shot = {
    /**
     * ID of the shot
     */
    id: string;
    /**
     * ID of the workspace
     */
    workspaceId: string;
    /**
     * ID of the project
     */
    projectId: string;
    /**
     * ID of the judge
     */
    judgeId: string;
    /**
     * The prompt
     */
    prompt: string;
    /**
     * The response
     */
    response: string;
    /**
     * The context passed to the LLM
     */
    context: (Record<string, any> | string);
    /**
     * A list of tools available to the LLM.
     */
    tools: Array<{
        type: 'function';
        function: {
            name: string;
            description?: string;
            parameters: Record<string, any>;
        };
    }> | null;
    critique: {
        /**
         * A critique of the provided response
         */
        critique: string;
        outcome: Shot.outcome;
    };
    createdBy: string;
    ownerId: string;
    lastEditedBy: string;
    created: string;
    updated: string;
    _object: Shot._object;
};
export namespace Shot {
    export enum outcome {
        PASS = 'pass',
        FAIL = 'fail',
    }
    export enum _object {
        SHOT = 'shot',
    }
}

